export const routes = {
  dashboard: '/dashboard',
  editProfile: '/profile/edit',
  myProfile: '/profile',
  personalImprovement: '/personal-improvement',
  myEmployees: '/employees',
  selectedEmployee: '/employees/:id',
};
